// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/company-13th-settings",
  Detail: "/pyr/company-13th-settings/{id}",
  Create: "/pyr/company-13th-settings",
  Update: "/pyr/company-13th-settings/{id}",
};
